import type { CopilotOverlayStore } from '@/shared/stores/ui';

import type { SourceProposedActionT } from '@/shared/lib';

export interface DiagnoseWizardPrefill {
  /**
   * Bare ICD-10 code (e.g. ``E11.9``). The description is resolved from the
   * code when the form opens, so callers never need to supply it.
   */
  icd10Code?: string;
  note?: string;
  sourceProposedAction?: SourceProposedActionT;
}

declare module '@/shared/stores/ui/copilotOverlay' {
  interface CopilotOverlayPayloads {
    diagnoseWizard: DiagnoseWizardPrefill | null;
  }
}

/**
 * Open the diagnose form. Pass ``null`` to open it empty for manual entry, or a
 * prefill to seed it from a ``diagnose`` proposed action (proposed by Cortex or
 * the action reviewer).
 */
export function openDiagnoseWizardOverlay(
  overlays: CopilotOverlayStore,
  prefill: DiagnoseWizardPrefill | null
): void {
  overlays.open('diagnoseWizard', prefill);
}
